import {v4 as uuidv4} from 'uuid';
import {getEnv} from '../../common/env/env';
import {HelixSeriesListResultVo} from '../../common/shared/api/nicolas/vo/HelixSeriesListResultVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {parseDate} from '../../common/shared/utils/parseDate';
import {verifyHelixExpireDate} from '../../domain/helix/landing/util/verifyHelixExpireDate';
import {HelixSeriesList} from '../generated/types';
import {createHelixSeries} from './HelixSeries';

export function createHelixSeriesList({
  uid,
  ticket_expire_dt,
  nickname,
  series_id,
  series_title,
  series_thumbnail_url,
  description,
  notification,
  list,
  age_grade,
  self_censorship,
}: HelixSeriesListResultVo): HelixSeriesList {
  return {
    id: uuidv4(),
    uid,
    ticketExpireDt: ticket_expire_dt,
    nickname,
    seriesId: series_id,
    seriesTitle: series_title,
    seriesThumbnailUrl: getKageUrl({
      kageUrlPrefix: getEnv().kageUrlPrefix,
      kageId: series_thumbnail_url,
      resolution: 'o1',
    }),
    description,
    notification,
    ageGradeNum: age_grade,
    selfCensorship: self_censorship,
    status: verifyHelixExpireDate(parseDate(ticket_expire_dt)),
    list:
      list
        ?.map(helixItem => createHelixSeries(helixItem, series_id))
        .sort((a, b) => a.itemOrder - b.itemOrder) || [],
  };
}
